import { sendNwReq } from './index'
import { PAGE_MEDIA_AWARDS } from './queries/pages'

async function fetchMagazineData(mediaId, magazineId) {
  const wrappedData = await sendNwReq(PAGE_MEDIA_AWARDS, {
    mediaId: mediaId,
    magazineId: magazineId,
  })

  return wrappedData?.data || {}
}

export { fetchMagazineData }
